const getClassName = (needs_actualization, row) => {
  if (needs_actualization && row.className) return `${row.className} warning`;
  if (needs_actualization) return 'warning';
  return row.className;
};
export default getClassName;
